import React, { useCallback, useEffect, useState } from "react";
import DateBox from "devextreme-react/date-box";
import { startDayDateBefore, startYestardayDate } from "shared/helpers/utils";
import { usePreferences } from "customer/settings/preferences/preferences.service";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { balanceFilterAtom } from "customer/orders/myBalance/my-balance.service";

const OrderHeader = ({ title, handleSortDate }) => {
  const{t}=useTranslation();
  const { ownerPerfrences } = usePreferences();
  const [myBalance, setMyBalance] = useRecoilState(balanceFilterAtom);

  const now = new Date();
  const [formDate, setFormDate] = useState({ from: startYestardayDate(), to: now });

  useEffect(() => {
    handleSortDate(formDate);
  }, [formDate, handleSortDate]);

   

  useEffect(() =>{
    if (ownerPerfrences?.defaultFilterPeriodDaysCount > 0) {
    setFormDate({ from: startDayDateBefore(ownerPerfrences?.defaultFilterPeriodDaysCount), to: formDate.to });
    setMyBalance({startDate:startDayDateBefore(ownerPerfrences?.defaultFilterPeriodDaysCount)})
  } else {
    setFormDate({ from: startYestardayDate(), to: formDate.to });
    setMyBalance({startDate:startYestardayDate()})

  }} ,[ownerPerfrences?.defaultFilterPeriodDaysCount])

  return (
    <div className="order-header">
      <div className="header">
        <div className="page-name">
          <h1 className="title">{title}</h1>
        </div>
        <div className="action">
          {/* <img className='icon-filter' data-toggle="tooltip" data-placement="bottom" title="filter" src={open ? FilterClose :  Filter} alt="Filter" onClick={SetOpen}/>
            <img className='icon-sort' data-toggle="tooltip" data-placement="bottom" title="sort"  src={Sort} alt="sort" /> */}

          <label className="selectCustom">
            {/* <span>{t('dxf-grid.from')}: </span> */}
            <DateBox
              value={formDate.from}
              type="date"
              onValueChange={(e) => {setFormDate({ from: e, to: formDate.to }); setMyBalance({startDate:e})}}
              displayFormat="dd/MM/yyyy"
            />
          </label>
          <label className="selectCustom">
            {/* <span className="customTo">{t('dxf-grid.to')} : </span> */}
            <DateBox
              defaultValue={now}
              type="date"
              onValueChange={(e) => setFormDate({ from: formDate.from, to: e })}
              displayFormat="dd/MM/yyyy"
            />
          </label>
        </div>
      </div>
    </div>
  );
};

export default OrderHeader;
